<template>
  <kst-table paginated view-mode
    :data="items"
    :selected.sync="userData.selected"
  >
    <b-table-column
      v-slot="{ column, row }"
      field="Name"
      :label="Catalog.Name.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column
      cell-class="ks-col-alias"
      field="Alias"
      :label="Catalog.Alias.Label"
      v-slot="{ column, row }"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column
      field="Address"
      :label="ClientAddressCatalog.Address.Label"
      v-slot="{ column, row }"
    >
      <kst-value :field="column.field" :data="row" :catalog="ClientAddressCatalog"/>
    </b-table-column>

    <b-table-column
      field="ContactMobile"
      :label="ClientAddressCatalog.ContactMobile.Label"
      v-slot="{ column, row }"
    >
      <kst-value :field="column.field" :data="row" :catalog="ClientAddressCatalog"/>
    </b-table-column>

    <b-table-column
      field="ContactPhone"
      :label="ClientAddressCatalog.ContactPhone.Label"
      v-slot="{ column, row }"
    >
      <kst-value :field="column.field" :data="row" :catalog="ClientAddressCatalog"/>
    </b-table-column>

    <b-table-column
      field="ContactEmail"
      :label="ClientAddressCatalog.ContactEmail.Label"
      v-slot="{ column, row }"
    >
      <kst-value :field="column.field" :data="row" :catalog="ClientAddressCatalog"/>
    </b-table-column>
  </kst-table>
</template>

<script>
import Catalog from "../CliCatalog.js";
import ClientAddressCatalog from "../CliaCatalog.js";

export default {
  props: {
    items: Array,
    userData: Object
  },
  data: () => ({
    Catalog: Catalog,
    ClientAddressCatalog: ClientAddressCatalog
  })
}
</script>